import "../Static Files/styles/Instagram page/instagram.css";
import hero from "../Static Files/Images/instagram/Hero Bg.png";
import img1 from "../Static Files/Images/instagram/Image 1.jpg";
import img2 from "../Static Files/Images/instagram/Image 10.jpg";
import img3 from "../Static Files/Images/instagram/Image 11.jpg";
import img4 from "../Static Files/Images/instagram/Image 13.jpg";
import img5 from "../Static Files/Images/instagram/Image 14.jpg";
import img6 from "../Static Files/Images/instagram/Image 15.jpg";
import img7 from "../Static Files/Images/instagram/Image 16.jpg";
import img8 from "../Static Files/Images/instagram/Image 17.jpg";
import img9 from "../Static Files/Images/instagram/Image 18.jpg";
import img10 from "../Static Files/Images/instagram/Image 19.jpg";
import { useLocation } from "react-router-dom";
import translation from "../locales";

const Instagram = () => {
  const location = useLocation();
  
  const lang = location.pathname.split("/")[1];
  const currentLang = translation[lang] ? lang : "az";
  return (
    <>
      <main>
        <section className="instagram-hero">
          <div className="texts-div">
            <h1 dangerouslySetInnerHTML={{
    __html: translation[currentLang].instagramh1,
}}></h1>
            <p>
              {translation[currentLang].instagramp}
            </p>
            <a target="_blank" href="https://www.instagram.com/joyfultravel.az/">{translation[currentLang].instagrambutton}</a>
          </div>
          <img src={hero} alt="background-image" />
        </section>

        <section className="posts-section">
          <div className="line-div">
            <hr />
            Daha çox paylaşımlar üçün Instagram səhifəmizə baxın
            <hr />
          </div>

          <div className="first-gallery">
            <ul>
              <li>
                <img src={img1} alt="jdnbevtwybh" />
              </li>

              <li>
                <img src={img2} alt="jdnbevtwybh" />
              </li>

              <li>
                <img src={img3} alt="jdnbevtwybh" />
              </li>

              <li>
                <img src={img4} alt="jdnbevtwybh" />
              </li>
            </ul>
            <img className="large-image" src={img5} alt="" />
          </div>
          <div className="second-gallery">
            <img className="large-image" src={img6} alt="" />
            <ul>
              <li>
                <img src={img7} alt="jdnbevtwybh" />
              </li>

              <li>
                <img src={img8} alt="jdnbevtwybh" />
              </li>

              <li>
                <img src={img9} alt="jdnbevtwybh" />
              </li>

              <li>
                <img src={img10} alt="jdnbevtwybh" />
              </li>
            </ul>
          </div>
        </section>
      </main>
    </>
  );
};

export default Instagram;
